import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { font, colors, zindex, breakpoints, spacing, visuallyHiddenCss } from '@chegg-ui/theme';
import { Link } from '@chegg-ui/link';
import { SkipLink } from '@chegg-ui/skiplink';
import styled, { css } from 'styled-components';
export var styledSpacing = _objectSpread(_objectSpread({}, spacing), {}, {
  px3: '0.1875rem',
  px13: '0.8125rem',
  px20: '1.25rem',
  px28: '1.75rem',
  px30: '1.875rem',
  px42: '2.625rem',
  px44: '2.75rem'
}); // The container to wrap the the Header

export var SignedOutHeaderContainer = styled.header.withConfig({
  componentId: "sc-4doro-0"
})(["display:flex;justify-content:center;align-items:center;margin:0;font-family:", ";width:100%;background-color:", ";", ""], font.family["default"], colors.white, function (props) {
  if (!props.scrollWithPage) {
    return "\n        position: fixed;\n        z-index: ".concat(parseInt(zindex.dropdown) + 1, ";\n      ");
  }
});
export var SearchContainer = styled.div.withConfig({
  componentId: "sc-4doro-1"
})(["display:flex;justify-content:center;align-items:center;padding:0 ", ";box-sizing:border-box;", " >:first-child{max-width:33.5rem;flex-grow:1;}@media (max-width:", "){border-bottom:none;justify-content:flex-start;}"], styledSpacing.px16, function (props) {
  if (props.showBorder) return "border-bottom: 2px solid ".concat(colors.greyLight, ";");
}, breakpoints.md.max);
export var HighZindexSkipLink = styled(SkipLink).withConfig({
  componentId: "sc-4doro-2"
})(["z-index:", ";"], zindex.sledgehammer);
export var Spacer = styled.div.withConfig({
  componentId: "sc-4doro-3"
})(["height:calc(", " + ", ");@media (max-width:", "){height:calc(", " + ", ");}"], styledSpacing.px32, styledSpacing.px40, breakpoints.md.max, styledSpacing.px24, styledSpacing.px42);
var navContainerCss = css(["box-sizing:border-box;display:flex;flex-grow:1;margin:0;"]);
export var DesktopHeaderContainer = styled.div.withConfig({
  componentId: "sc-4doro-4"
})(["", " padding:", " ", ";justify-content:space-between;align-items:center;max-width:", ";min-width:", ";"], navContainerCss, styledSpacing.px16, styledSpacing.px32, breakpoints.lg.max, breakpoints.lg.min);
export var MobileHeaderContainer = styled.div.withConfig({
  componentId: "sc-4doro-5"
})(["", " padding:", ";justify-content:flex-start;align-items:center;max-width:", ";min-width:", ";position:relative;"], navContainerCss, styledSpacing.px12, breakpoints.md.max, breakpoints.sm.min);
export var CheggLogoLink = styled(Link).withConfig({
  componentId: "sc-4doro-6"
})(["display:flex;&:link,&:visited,&:hover,&:active{text-decoration:none;}> svg{width:5.5rem;height:", ";}"], styledSpacing.px30);
export var Divider = styled.div.withConfig({
  componentId: "sc-4doro-7"
})(["border-bottom:2px solid ", ";margin:", " 0;"], colors.greyLight, spacing.px16);
export var VisuallyHidden = styled.span.withConfig({
  componentId: "sc-4doro-8"
})(["", ""], visuallyHiddenCss);